import erc20Abi from "./abis/erc20.json";
import ownableAbi from "./abis/ownable.json";
import kanjiAbi from "./abis/Kanji.json";

const abis = {
  erc20: erc20Abi,
  ownable: ownableAbi,
  kanji: kanjiAbi,
};

export default abis;
